module.exports = __webpack_public_path__ + "img/medialuna.ef5b4545.jpeg";